import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        bannerContainer: {
            w: '100%',
            h: '100%',
            flexDir: {base: 'column-reverse', lg: 'row'},
            justifyContent: 'space-between',
            alignItems: 'center',
            bg: 'background.light-dark',
            paddingY: {base: 'small.base', lg: 0},
            gap: 'medium.base',
        },
        infoContainer: {
            flexDir: 'column',
            alignItems: {base: 'center', lg: 'unset'},
            gap: {base: 'medium.base', lg: 'xlarge.base'},
            w: {base: '100%', lg: '50%'},
            maxW: remCalc(561),
            h: '100%',
            maxHeight: remCalc(578),
            paddingY: {lg: 'large.lg'},
        },
        mediaContainer: {
            w: {base: remCalc(342), sm: remCalc(342), md: remCalc(780), lg: remCalc(780)},
            h: {base: remCalc(342), sm: remCalc(342), md: remCalc(590), lg: remCalc(590)},
            maxW: remCalc(780),
            maxH: remCalc(590),
            justifyContent: {base: 'center', lg: 'flex-end'},
            overflow: 'hidden',
        },
        recipeInfoContainer: {
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: 'medium.base',
            alignSelf: 'stretch',
            textAlign: 'start',
        },
        infoTitle: {
            color: 'text.default',
            textAlign: {base: 'center', lg: 'start'},
            alignSelf: 'stretch',
            textStyle: 'head-large',
            fontWeight: 'semibold',
        },
        description: {
            color: 'text.secondary',
            alignSelf: 'stretch',
            textStyle: 'body-small',
            fontWeight: 'normal',
        },
        buttonContainer: {
            flexDir: {base: 'column', lg: 'row'},
            alignItems: {base: 'center', lg: 'flex-start'},
            gap: 'medium.base',
            alignSelf: {base: 'center', lg: 'flex-start'},
        },
        infoBottomContainer: {
            justifyContent: {base: 'center', lg: 'flex-start'},
            alignItems: 'center',
            gap: 'medium.base',
            w: '100%',
            maxW: {base: remCalc(375), lg: '100%'},
            paddingX: {base: 'small.base', lg: 'unset'},
            flexWrap: {base: 'wrap', lg: 'unset'},
        },
        infoTileContainer: {
            flexDir: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 'small.base',
        },
        infoTileTextContainer: {
            flexDir: 'column',
            gap: 'xxsmall.base',
        },
        infoTileTitle: {
            color: 'text.tertiary',
            textStyle: 'head-xxsmall',
            fontWeight: 'semibold',
        },
        infoTileText: {
            color: 'text.secondary',
            textStyle: 'body-small',
            fontWeight: 'normal',
            minW: remCalc(50),
            whiteSpace: 'nowrap',
        },
        infoIcons: {
            color: 'text.tertiary',
            w: 'iconsSize.xlarge',
            h: 'iconsSize.xlarge',
        },
    },
}
